(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mublio-bewaard"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SLEUTEL = 'mb-bewaard';

    function lees() {
      try {
        var lijst = JSON.parse(localStorage.getItem(SLEUTEL) || '[]');
        return Array.isArray(lijst) ? lijst : [];
      } catch (e) {
        return [];
      }
    }
    function schrijf(lijst) {
      try { localStorage.setItem(SLEUTEL, JSON.stringify(lijst)); } catch (e) {}
      document.dispatchEvent(new CustomEvent('mb:bewaard', { detail: { aantal: lijst.length } }));
    }

    function geld(centen, formaat) {
      var n = Number(centen) / 100;
      function groep(getal, decimalen, duizend, decimaal) {
        var delen = getal.toFixed(decimalen).split('.');
        delen[0] = delen[0].replace(/\B(?=(\d{3})+(?!\d))/g, duizend);
        return delen.join(decimaal);
      }
      var vormen = {
        amount: function () { return groep(n, 2, ',', '.'); },
        amount_no_decimals: function () { return groep(n, 0, ',', '.'); },
        amount_with_comma_separator: function () { return groep(n, 2, '.', ','); },
        amount_no_decimals_with_comma_separator: function () { return groep(n, 0, '.', ','); },
        amount_with_apostrophe_separator: function () { return groep(n, 2, "'", '.'); },
        amount_with_space_separator: function () { return groep(n, 2, ' ', ','); }
      };
      return String(formaat || ('€{' + '{amount_with_comma_separator}}')).replace(/\{\{\s*(\w+)\s*\}\}/, function (_, sleutel) {
        return (vormen[sleutel] || vormen.amount_with_comma_separator)();
      });
    }

    function foto(src, breedte) {
      if (!src) return '';
      var url = src.indexOf('//') === 0 ? 'https:' + src : src;
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + breedte;
    }

    function esc(t) {
      return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    var cache = {};
    function product(handle) {
      if (!cache[handle]) {
        cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      }
      return cache[handle];
    }

    function render(root) {
      var config = {};
      try { config = JSON.parse(root.querySelector('[data-mb-bew-config]').textContent); } catch (e) {}
      var lijst = lees();
      var laden = root.querySelector('[data-mb-bew-laden]');
      var leeg = root.querySelector('[data-mb-bew-leeg]');
      var inhoud = root.querySelector('[data-mb-bew-inhoud]');
      var ul = root.querySelector('[data-mb-bew-lijst]');
      var icoon = root.querySelector('[data-mb-bew-icoon-verwijder]');
      var icoonHtml = icoon ? icoon.innerHTML : '';

      if (!lijst.length) {
        laden.hidden = true;
        inhoud.hidden = true;
        leeg.hidden = false;
        return;
      }

      Promise.all(lijst.map(function (r) { return product(r.handle); })).then(function (producten) {
        var totaal = 0;
        var regels = [];
        var html = lijst.map(function (r, i) {
          var p = producten[i];
          if (!p) return '';
          var v = (p.variants || []).find(function (x) { return String(x.id) === String(r.variant); });
          if (!v) return '';
          var aantal = Number(r.aantal) || 1;
          totaal += v.price * aantal;
          var url = p.url + '?variant=' + v.id;
          var beeld = (v.featured_image && v.featured_image.src) || p.featured_image;
          var details = (v.options || []).filter(function (o) { return o && o !== 'Default Title'; }).join(' / ');
          regels.push({ titel: p.title, details: details, url: location.origin + url });
          return (
            '<li class="mb-bew__regel" data-variant="' + esc(v.id) + '">' +
              '<a class="mb-bew__foto" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' +
                (beeld ? '<img src="' + esc(foto(beeld, 160)) + '" alt="" width="64" height="64" loading="lazy">' : '') +
              '</a>' +
              '<div class="mb-bew__tekst">' +
                '<a class="mb-bew__naam" href="' + esc(url) + '">' + esc(p.title) + '</a>' +
                (details ? '<span class="mb-bew__details">' + esc(details) + '</span>' : '') +
                '<button type="button" class="mb-bew__verwijder" data-mb-bew-verwijder="' + esc(v.id) + '">' +
                  icoonHtml + '<span>' + esc(config.verwijderLabel || 'Verwijderen') + '</span>' +
                '</button>' +
              '</div>' +
              '<span class="mb-bew__prijs">' + esc(geld(v.price * aantal, config.moneyFormat)) + '</span>' +
            '</li>'
          );
        }).join('');

        laden.hidden = true;
        if (!html) {
          inhoud.hidden = true;
          leeg.hidden = false;
          return;
        }
        ul.innerHTML = html;
        root.querySelector('[data-mb-bew-totaal]').textContent = geld(totaal, config.moneyFormat);
        leeg.hidden = true;
        inhoud.hidden = false;

        var wa = root.querySelector('[data-mb-bew-whatsapp]');
        if (wa) {
          var basis = wa.getAttribute('href').split('?')[0];
          var tekst = (wa.dataset.bericht || '') + '\n\n' + regels.map(function (x) {
            return x.url;
          }).join('\n');
          wa.setAttribute('href', basis + '?text=' + encodeURIComponent(tekst.trim()));
        }
      });
    }

    function init() {
      document.querySelectorAll('[data-mb-bewaard-pagina]').forEach(function (root) {
        if (root.dataset.mbBewInit) return;
        root.dataset.mbBewInit = '1';
        root.addEventListener('click', function (e) {
          var knop = e.target.closest('[data-mb-bew-verwijder]');
          if (!knop) return;
          var id = knop.getAttribute('data-mb-bew-verwijder');
          schrijf(lees().filter(function (r) { return String(r.variant) !== String(id); }));
          render(root);
        });
        render(root);
      });
    }

    window.addEventListener('pageshow', function (e) {
      if (e.persisted) document.querySelectorAll('[data-mb-bewaard-pagina]').forEach(render);
    });
    window.addEventListener('storage', function (e) {
      if (e.key === SLEUTEL) document.querySelectorAll('[data-mb-bewaard-pagina]').forEach(render);
    });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mublio-extras"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (slider) => {
      if (slider.dataset.mbReady) return;
      slider.dataset.mbReady = '1';
      const track = slider.querySelector('[data-mb-ex-track]');
      const vorige = slider.querySelector('[data-mb-ex-vorige]');
      const volgende = slider.querySelector('[data-mb-ex-volgende]');
      const stap = () => {
        const item = track.querySelector('.mb-rv__item');
        if (!item) return track.clientWidth;
        return item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
      };
      const update = () => {
        const max = track.scrollWidth - track.clientWidth - 2;
        if (vorige) vorige.disabled = track.scrollLeft <= 2;
        if (volgende) volgende.disabled = track.scrollLeft >= max;
        const fotos = track.querySelectorAll('.mb-ex__foto'); const foto = fotos[fotos.length - 1];
        if (foto) slider.style.setProperty('--mb-ex-pijl', foto.offsetHeight / 2 + 'px');
      };
      const schuif = (richting) => {
        const zichtbaar = Math.max(1, Math.floor((track.clientWidth + 1) / stap()));
        track.scrollBy({ left: richting * zichtbaar * stap() });
      };
      vorige?.addEventListener('click', () => schuif(-1));
      volgende?.addEventListener('click', () => schuif(1));
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    };
    const start = () => document.querySelectorAll('[data-mb-ex]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mublio-faq"] && !Shopify.designMode) return;
  try {
    
  /* Specificaties: de tekst van de gekozen variant tonen (variantkiezer op de productpagina) */
  (function () {
    function toon() {
      var spec = document.querySelector('[data-mb-spec]');
      if (!spec || !spec.querySelector('[data-mb-spec-variant]')) return;
      var veld = document.querySelector('.product-information__grid product-form-component input[name="id"]');
      var id = veld && veld.value;
      if (!id) return;
      spec.querySelectorAll('[data-mb-spec-variant]').forEach(function (p) { p.hidden = p.getAttribute('data-mb-spec-variant') !== String(id); });
    }
    document.addEventListener('change', function (e) {
      if (!e.target.closest || !e.target.closest('variant-picker')) return;
      [300, 1000, 2500].forEach(function (t) { setTimeout(toon, t); });
    });
  })();
  /* Eén vraag tegelijk open op de hele pagina. Browsers met ondersteuning voor details[name] doen dit zelf; dit is de terugval. */
  document.addEventListener('toggle', function (e) {
    var el = e.target;
    if (!el.matches || !el.matches('details.mb-faq__item') || !el.open) return;
    document.querySelectorAll('details.mb-faq__item[open]').forEach(function (d) { if (d !== el) d.open = false; });
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mublio-inspiratie"] && !Shopify.designMode) return;
  try {
    
  /*
    Opbergtegels met video:
    - de eerste video-tegel speelt zodra de sectie in beeld is, daarna de volgende (optie: herhalen);
    - hover over een video-tegel speelt die video opnieuw vanaf het begin;
    - een tik op een deurtje (touch) speelt die video ook;
    - pauze buiten beeld; geen automatisch afspelen bij "beperkte beweging".
  */
  class MbTegels extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('.mb-tegel[data-video]')].filter((tegel) => tegel.querySelector('video'));
      if (!this.items.length) return;

      this.index = 0;
      this.zichtbaar = false;
      this.klaar = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const kanHoveren = window.matchMedia('(hover: hover)').matches;

      this.items.forEach((tegel, i) => {
        const video = tegel.querySelector('video');
        video.muted = true;
        video.playsInline = true;
        video.loop = false;
        video.removeAttribute('autoplay');
        video.addEventListener('ended', () => this.einde(i));
        if (kanHoveren) tegel.addEventListener('mouseenter', () => this.hover(i));
      });

      this.addEventListener('mb-deurtje', (event) => {
        const i = this.items.indexOf(event.target);
        if (i >= 0 && event.detail?.open) this.hover(i);
      });

      this.observer = new IntersectionObserver(
        ([entry]) => {
          this.zichtbaar = entry.isIntersecting && entry.intersectionRatio >= 0.25;
          if (this.zichtbaar) this.speel();
          else this.pauzeer();
        },
        { threshold: [0, 0.25] }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }

    get video() {
      return this.items[this.index]?.querySelector('video');
    }

    start(i) {
      this.index = i;
      this.items.forEach((tegel, n) => tegel.classList.toggle('is-spelend', n === i));
      this.video.play()?.catch(() => {});
      this.volg();
    }

    speel() {
      if (!this.video || this.klaar) return;
      this.start(this.index);
    }

    pauzeer() {
      this.video?.pause();
      cancelAnimationFrame(this.frame);
    }

    reset(i) {
      const tegel = this.items[i];
      const video = tegel.querySelector('video');
      video.pause();
      video.currentTime = 0;
      tegel.style.setProperty('--mb-voortgang', '0');
      tegel.classList.remove('is-spelend');
    }

    hover(i) {
      const video = this.items[i].querySelector('video');
      if (i === this.index && !video.paused) return;
      cancelAnimationFrame(this.frame);
      this.reset(this.index);
      video.currentTime = 0;
      this.start(i);
    }

    volg() {
      cancelAnimationFrame(this.frame);
      const stap = () => {
        const video = this.video;
        if (video && video.duration) {
          this.items[this.index].style.setProperty('--mb-voortgang', (video.currentTime / video.duration).toFixed(4));
        }
        this.frame = requestAnimationFrame(stap);
      };
      stap();
    }

    einde(i) {
      cancelAnimationFrame(this.frame);
      this.reset(i);
      if (this.klaar) return;

      let volgende = i + 1;
      if (volgende >= this.items.length) {
        if (!this.hasAttribute('herhalen')) {
          this.klaar = true;
          return;
        }
        volgende = 0;
      }

      this.index = volgende;
      if (this.zichtbaar) this.speel();
    }
  }

  if (!customElements.get('mb-tegels')) customElements.define('mb-tegels', MbTegels);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mublio-inspiratiefeed"] && !Shopify.designMode) return;
  try {
    
  class MbFeed extends HTMLElement {
    connectedCallback() {
      this.posts = [...this.querySelectorAll('.mb-post')];
      this.leeg = this.querySelector('.mb-feed__leeg');
      this.lijst = this.querySelector('.mb-feed__lijst');
      this.filterBalk = this.querySelector('.mb-feed__filter');
      this.modal = this.querySelector('[data-modal]');
      this.stil = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.desktop = window.matchMedia('(min-width: 750px)');

      this.posts.forEach((post) => this.slides(post));
      this.voorna(this);
      this.videos();
      this.sticky();
      this.modalInit();

      this.querySelectorAll('[data-deel]').forEach((knop) => knop.addEventListener('click', () => this.deel(knop)));
      this.querySelectorAll('.mb-post [data-wa]').forEach((link) => link.addEventListener('click', () => this.meet('inspiratie_whatsapp', link)));
      this.querySelectorAll('[data-overzicht]').forEach((details) => details.addEventListener('toggle', () => {
        if (details.open) this.meet('inspiratie_producten', details);
      }));

      /* Desktop: 'Bekijk producten & prijzen' opent de modal in plaats van uit te klappen */
      this.querySelectorAll('.mb-post__toggle').forEach((summary) => summary.addEventListener('click', (event) => {
        if (!this.desktop.matches || !this.modal) return;
        event.preventDefault();
        this.open(summary.closest('.mb-post'));
      }));

      this.addEventListener('click', (event) => {
        const chip = event.target.closest('.mb-feed__chip');
        if (!chip) return;
        event.preventDefault();
        this.filter(chip.dataset.wens, true);
      });

      const params = new URLSearchParams(window.location.search);
      const start = params.get('opbergwens');
      if (start) this.filter(start, false);

      /* Vanaf een opbergtegel op home (?opbergwens=<wens>&post=<handle>):
         desktop alleen gefilterd; mobiel staat de aangeklikte post bovenaan de feed en scrolt de pagina ernaartoe. */
      const post = params.get('post');
      if (post && !this.desktop.matches) this.bovenaan(post);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      this.headerObserver?.disconnect();
      document.removeEventListener('scroll', this.onScroll, true);
      window.removeEventListener('resize', this.onScroll);
    }

    /*
      Filter sticky direct onder het menu. Het menu is 'sticky bij omhoog scrollen': het wordt pas sticky (en zichtbaar)
      als je omhoog scrolt. Daarom bij elke scrollbeweging de onderkant van het menu meten (> 0 = menu in beeld).
      Mobiel: zodra de balk vastzit verdwijnt hij bij naar beneden scrollen (.is-weg) en komt hij terug bij omhoog scrollen.
      Scrollrichting = verschuiving van de lijst, zodat het werkt of de pagina of .page-wrapper scrolt.
    */
    sticky() {
      if (!this.filterBalk) return;
      const header = document.querySelector('#header-component') || document.querySelector('header');

      let frame;
      let vorigeTop = null;
      const meet = () => {
        let top = 0;
        if (header) {
          const rect = header.getBoundingClientRect();
          if (rect.bottom > 0 && rect.top <= 1) top = Math.round(rect.bottom);
        }
        const hoogte = Math.round(this.filterBalk.offsetHeight);
        this.style.setProperty('--mb-sticky-top', `${top}px`);
        this.style.setProperty('--mb-filter-h', `${hoogte}px`);

        const lijstTop = this.lijst ? this.lijst.getBoundingClientRect().top : 0;
        const verschil = vorigeTop === null ? 0 : lijstTop - vorigeTop;
        vorigeTop = lijstTop;

        /* Plek van de balk als hij niet vast zou zitten: boven de lijst */
        const ruimte = parseFloat(getComputedStyle(this).rowGap) || 0;
        const vast = lijstTop - ruimte - hoogte < top - 1;

        if (this.desktop.matches || !vast) {
          this.filterBalk.classList.remove('is-weg');
        } else if (verschil < -4) {
          this.filterBalk.classList.add('is-weg');
        } else if (verschil > 4) {
          this.filterBalk.classList.remove('is-weg');
        }
      };
      this.onScroll = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(meet);
      };
      document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
      window.addEventListener('resize', this.onScroll);
      if (header) {
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.onScroll);
          this.resizeObserver.observe(header);
        }
        /* Het thema zet data-sticky-state en data-scroll-direction op het menu; bij elke wijziging opnieuw meten */
        this.headerObserver = new MutationObserver(this.onScroll);
        this.headerObserver.observe(header, { attributes: true });
        if (header.parentElement) this.headerObserver.observe(header.parentElement, { attributes: true });
        /* Het menu schuift met een overgang in en uit: tijdens en na de overgang opnieuw meten */
        header.addEventListener('transitionrun', this.onScroll);
        header.addEventListener('transitionend', this.onScroll);
      }
      meet();
    }

    filter(wens, door_klik) {
      let zichtbaar = 0;
      this.posts.forEach((post) => {
        const toon = !wens || ` ${post.dataset.wensen} `.includes(` ${wens} `);
        post.hidden = !toon;
        if (toon) zichtbaar++;
      });
      this.querySelectorAll('.mb-feed__chip').forEach((chip) => chip.setAttribute('aria-current', chip.dataset.wens === (wens || '') ? 'true' : 'false'));
      if (this.leeg) this.leeg.hidden = zichtbaar > 0;

      if (door_klik) {
        const url = new URL(window.location.href);
        url.hash = '';
        if (wens) url.searchParams.set('opbergwens', wens);
        else url.searchParams.delete('opbergwens');
        url.searchParams.delete('post');
        history.replaceState(null, '', url);

        /* Terug naar het begin van de lijst als je al verder gescrold was */
        const grens = (parseFloat(getComputedStyle(this).getPropertyValue('--mb-sticky-top')) || 0) + (this.filterBalk?.offsetHeight || 0);
        if (this.lijst && this.lijst.getBoundingClientRect().top < grens) {
          this.lijst.scrollIntoView({ block: 'start', behavior: this.stil ? 'auto' : 'smooth' });
        }
      }
    }

    bovenaan(handle) {
      const el = this.posts.find((p) => p.id === handle);
      if (!el || el.hidden || !this.lijst) return;
      this.lijst.prepend(el);
      this.posts = [...this.querySelectorAll('.mb-post')];
      requestAnimationFrame(() => requestAnimationFrame(() => {
        this.onScroll?.();
        el.scrollIntoView({ block: 'start', behavior: 'auto' });
      }));
    }

    /*
      Voor/na-slider: --pos (0-100) = plek van de lijn in het midden (hoogte 50%). De lijn loopt schuin:
      boven op pos + schuin/2, onder op pos - schuin/2. Slepen op de foto of de greep; muis: klikken springt ook.
      Touch: alleen horizontaal slepen (touch-action: pan-y), zodat verticaal scrollen blijft werken.
    */
    voorna(container) {
      container.querySelectorAll('[data-voorna]').forEach((el) => {
        const greep = el.querySelector('.mb-voorna__greep');
        const lijn = el.querySelector('.mb-voorna__lijn line');
        const schuin = parseFloat(getComputedStyle(el).getPropertyValue('--schuin')) || 0;

        const zet = (waarde) => {
          const pos = Math.max(0, Math.min(100, waarde));
          el.dataset.pos = pos;
          el.style.setProperty('--pos', pos);
          lijn?.setAttribute('x1', pos + schuin / 2);
          lijn?.setAttribute('x2', pos - schuin / 2);
          greep?.setAttribute('aria-valuenow', Math.round(pos));
        };
        const vanPunt = (event) => {
          const r = el.getBoundingClientRect();
          const x = ((event.clientX - r.left) / r.width) * 100;
          const y = (event.clientY - r.top) / r.height;
          return x - schuin / 2 + schuin * y;
        };

        let actief = false;
        const inReeks = !!el.closest('[data-slides]');
        el.addEventListener('pointerdown', (event) => {
          if (event.button > 0) return;
          /* In een fotoreeks op touch alleen slepen aan de greep, zodat vegen over de foto naar de volgende foto gaat */
          if (inReeks && event.pointerType !== 'mouse' && !event.target.closest('.mb-voorna__greep')) return;
          actief = true;
          el.setPointerCapture?.(event.pointerId);
          if (event.pointerType === 'mouse') zet(vanPunt(event));
        });
        el.addEventListener('pointermove', (event) => { if (actief) zet(vanPunt(event)); });
        const stop = () => { actief = false; };
        el.addEventListener('pointerup', stop);
        el.addEventListener('pointercancel', stop);
        el.addEventListener('click', (event) => event.stopPropagation());

        greep?.addEventListener('keydown', (event) => {
          if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) event.stopPropagation();
          const pos = parseFloat(el.dataset.pos ?? 50);
          if (event.key === 'ArrowLeft') { event.preventDefault(); zet(pos - 5); }
          if (event.key === 'ArrowRight') { event.preventDefault(); zet(pos + 5); }
          if (event.key === 'Home') { event.preventDefault(); zet(0); }
          if (event.key === 'End') { event.preventDefault(); zet(100); }
        });

        zet(parseFloat(el.dataset.pos ?? 50));
      });
    }

    slides(container) {
      const baan = container.querySelector('[data-slides]');
      if (!baan || baan.children.length < 2) return;

      const aantal = baan.children.length;
      const vorige = container.querySelector('[data-vorige]');
      const volgende = container.querySelector('[data-volgende]');
      const stippen = [...container.querySelectorAll('.mb-post__stippen span')];

      const huidig = () => Math.round(baan.scrollLeft / (baan.clientWidth || 1));
      const naar = (i) => baan.scrollTo({ left: Math.max(0, Math.min(aantal - 1, i)) * baan.clientWidth, behavior: this.stil ? 'auto' : 'smooth' });
      const bij = () => {
        const i = huidig();
        stippen.forEach((stip, n) => stip.classList.toggle('is-actief', n === i));
        if (vorige) vorige.hidden = i === 0;
        if (volgende) volgende.hidden = i === aantal - 1;
      };

      let frame;
      baan.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(bij);
      }, { passive: true });
      vorige?.addEventListener('click', () => naar(huidig() - 1));
      volgende?.addEventListener('click', () => naar(huidig() + 1));
      baan.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') { event.preventDefault(); naar(huidig() + 1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); naar(huidig() - 1); }
      });
      bij();
    }

    videoKnop(blok) {
      const video = blok.querySelector('video');
      video.muted = true;
      video.playsInline = true;
      video.loop = true;
      video.controls = false;
      video.removeAttribute('autoplay');
      video.addEventListener('play', () => blok.classList.add('is-spelend'));
      video.addEventListener('pause', () => blok.classList.remove('is-spelend'));
      blok.querySelector('[data-speel]')?.addEventListener('click', () => {
        if (video.paused) {
          delete blok.dataset.gestopt;
          video.play()?.catch(() => {});
        } else {
          blok.dataset.gestopt = '';
          video.pause();
        }
      });
      return video;
    }

    videos() {
      const blokken = [...this.querySelectorAll('.mb-feed__lijst [data-video]')].filter((blok) => blok.querySelector('video'));
      if (!blokken.length) return;

      blokken.forEach((blok) => this.videoKnop(blok));
      if (this.stil) return;

      this.observer = new IntersectionObserver(
        (entries) => entries.forEach((entry) => {
          const blok = entry.target;
          const video = blok.querySelector('video');
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6 && !this.modal?.open) {
            if (!('gestopt' in blok.dataset)) video.play()?.catch(() => {});
          } else {
            video.pause();
          }
        }),
        { threshold: [0, 0.6] }
      );
      blokken.forEach((blok) => this.observer.observe(blok));
    }

    /* ===== Modal (desktop) ===== */
    modalInit() {
      const m = this.modal;
      if (!m) return;
      m.querySelector('[data-sluit]')?.addEventListener('click', () => m.close());
      m.addEventListener('click', (event) => { if (event.target === m) m.close(); });
      m.addEventListener('close', () => {
        m.querySelector('[data-modal-media]').replaceChildren();
        m.querySelector('[data-modal-overzicht]').replaceChildren();
        document.documentElement.classList.remove('mb-feed-modal-open');
        this.terug?.focus({ preventScroll: true });
      });
    }

    open(post) {
      const m = this.modal;
      if (!m || !post) return;
      this.terug = post.querySelector('.mb-post__toggle');

      /* Pauzeer de video's in de feed */
      this.querySelectorAll('.mb-feed__lijst video').forEach((video) => video.pause());

      const media = post.querySelector('.mb-post__media').cloneNode(true);
      media.querySelectorAll('img').forEach((img) => {
        img.sizes = '640px';
        img.loading = 'eager';
      });
      m.querySelector('[data-modal-media]').replaceChildren(media);

      m.querySelector('.mb-feed__modal-titel').textContent = post.querySelector('.mb-post__titel')?.textContent.trim() || '';

      const kaart = post.querySelector('.mb-post__kaart')?.cloneNode(true);
      m.querySelector('[data-modal-overzicht]').replaceChildren(...(kaart ? [kaart] : []));
      m.dataset.post = post.id;
      kaart?.querySelectorAll('[data-wa]').forEach((link) => link.addEventListener('click', () => this.meet('inspiratie_whatsapp', link)));

      m.showModal();
      document.documentElement.classList.add('mb-feed-modal-open');
      m.querySelector('.mb-feed__modal-inhoud').scrollTop = 0;

      this.slides(media);
      this.voorna(media);
      const blok = media.querySelector('[data-video]');
      if (blok) {
        const video = this.videoKnop(blok);
        if (!this.stil) video.play()?.catch(() => {});
      }

      this.meet('inspiratie_producten', post);
    }

    async deel(knop) {
      const url = knop.dataset.url;
      this.meet('inspiratie_delen', knop);

      if (navigator.share) {
        try {
          await navigator.share({ title: knop.dataset.titel, url });
          return;
        } catch (error) {
          if (error.name === 'AbortError') return;
        }
      }

      const status = knop.parentElement.querySelector('[data-status]');
      try {
        await navigator.clipboard.writeText(url);
        if (status) {
          status.textContent = this.dataset.gekopieerd;
          clearTimeout(knop.mbTimer);
          knop.mbTimer = setTimeout(() => { status.textContent = ''; }, 3000);
        }
      } catch (error) {
        window.prompt('', url);
      }
    }

    meet(event, element) {
      window.dataLayer = window.dataLayer || [];
      const project = element.closest('.mb-post')?.id || this.modal?.dataset.post;
      window.dataLayer.push({ event, inspiratie_project: project });
    }
  }

  if (!customElements.get('mb-feed')) customElements.define('mb-feed', MbFeed);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mublio-oneindig"] && !Shopify.designMode) return;
  try {
    
  class MbOneindig extends HTMLElement {
    async connectedCallback() {
      await customElements.whenDefined('mb-feed');
      this.feed = document.querySelector('mb-feed');
      if (!this.feed || !this.feed.lijst) return;
      this.rondes = 0;
      this.max = parseInt(this.dataset.max, 10) || 20;
      this.origineel = [...this.feed.querySelectorAll('.mb-post')];
      this.origineel.forEach((post) => { post.dataset.bron = post.id; });

      /* Analytics: kopieën hebben geen id, gebruik de handle van het origineel */
      const meet = this.feed.meet.bind(this.feed);
      this.feed.meet = (event, element) => {
        const post = element?.closest?.('.mb-post');
        if (post && !post.id && post.dataset.bron) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event, inspiratie_project: post.dataset.bron });
          return;
        }
        meet(event, element);
      };

      /* Ander filter: kopieën weg, opnieuw beginnen */
      const filter = this.feed.filter.bind(this.feed);
      this.feed.filter = (wens, door_klik) => {
        this.feed.querySelectorAll('.mb-post[data-kopie]').forEach((kopie) => kopie.remove());
        this.feed.posts = [...this.origineel];
        this.rondes = 0;
        filter(wens, door_klik);
        requestAnimationFrame(() => this.controleer());
      };

      /* De pagina scrolt in .page-wrapper (niet het venster): dat element als root, anders werkt de marge niet */
      const wrapper = this.closest('.page-wrapper');
      const root = wrapper && /(auto|scroll)/.test(getComputedStyle(wrapper).overflowY) ? wrapper : null;
      this.observer = new IntersectionObserver(([entry]) => { if (entry.isIntersecting) this.aanvullen(); }, { root, rootMargin: '0px 0px 1600px 0px' });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    controleer() {
      const r = this.getBoundingClientRect();
      if (r.top < window.innerHeight + 1600) this.aanvullen();
    }

    aanvullen() {
      if (this.bezig || this.rondes >= this.max) return;
      const zichtbaar = this.origineel.filter((post) => !post.hidden);
      if (zichtbaar.length < 2) return;
      this.bezig = true;
      this.rondes++;

      const feed = this.feed;
      const nieuw = zichtbaar.map((post) => {
        const kopie = post.cloneNode(true);
        kopie.removeAttribute('id');
        kopie.dataset.kopie = '';
        kopie.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
        kopie.querySelectorAll('details[open]').forEach((d) => d.removeAttribute('open'));
        kopie.querySelectorAll('[data-slides]').forEach((baan) => { baan.scrollLeft = 0; });
        return kopie;
      });
      feed.lijst.append(...nieuw);
      feed.posts = [...feed.querySelectorAll('.mb-post')];

      nieuw.forEach((post) => {
        feed.slides(post);
        feed.voorna(post);
        post.querySelectorAll('[data-video]').forEach((blok) => {
          if (!blok.querySelector('video')) return;
          feed.videoKnop(blok);
          feed.observer?.observe(blok);
        });
        post.querySelectorAll('[data-deel]').forEach((knop) => knop.addEventListener('click', () => feed.deel(knop)));
        post.querySelectorAll('[data-wa]').forEach((link) => link.addEventListener('click', () => feed.meet('inspiratie_whatsapp', link)));
        post.querySelectorAll('[data-overzicht]').forEach((details) => details.addEventListener('toggle', () => {
          if (details.open) feed.meet('inspiratie_producten', details);
        }));
        post.querySelectorAll('.mb-post__toggle').forEach((summary) => summary.addEventListener('click', (event) => {
          if (!feed.desktop.matches || !feed.modal) return;
          event.preventDefault();
          feed.open(post);
        }));
      });

      this.bezig = false;
      requestAnimationFrame(() => this.controleer());
    }
  }

  if (!customElements.get('mb-oneindig')) customElements.define('mb-oneindig', MbOneindig);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mublio-reviews-overzicht"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (sectie) => {
      if (sectie.dataset.mbReady) return;
      sectie.dataset.mbReady = '1';
      const lijst = sectie.querySelector('[data-mb-rvo-lijst]');
      const bron = sectie.querySelector('[data-mb-rvo-bron]');
      const einde = sectie.querySelector('[data-mb-rvo-einde]');
      const nav = sectie.querySelector('[data-mb-rvo-filter]');
      const knoppen = [...sectie.querySelectorAll('[data-mb-rvo-knop]')];
      const opties = [...sectie.querySelectorAll('.mb-filter__opties [data-groep]')];
      const wis = nav.querySelector('[data-mb-rvo-reset]');
      const leeg = sectie.querySelector('[data-mb-rvo-leeg]');
      const status = sectie.querySelector('[data-mb-rvo-status]');
      const perKeer = parseInt(sectie.dataset.perKeer, 10) || 24;
      const laagNa = (parseInt(sectie.dataset.laagNa, 10) || 3) * perKeer;
      const keuze = { sterren: '', onderwerp: '' };
      let data = [];
      let zichtbaar = perKeer;
      let kolommen = [];
      let geplaatst = 0;
      let lijstNu = [];

      /* Volgorde: reviews onder 4 sterren pas na laagNa reviews, daarna één per perKeer */
      const lees = () => {
        const alle = [...lijst.querySelectorAll('.mb-rvo__item')].map((item) => {
          const kaart = item.querySelector('[data-mb-rv-kaart]');
          return { item, sterren: kaart ? kaart.dataset.sterren : '', onderwerpen: kaart ? kaart.dataset.onderwerpen : '|' };
        });
        const hoog = alle.filter((d) => parseInt(d.sterren, 10) >= 4 || !d.sterren);
        const laag = alle.filter((d) => parseInt(d.sterren, 10) < 4);
        data = hoog.slice(0, laagNa);
        let rest = hoog.slice(laagNa);
        laag.forEach((d) => {
          data.push(d);
          data.push(...rest.splice(0, perKeer));
        });
        data.push(...rest);
      };

      const past = (d, k) =>
        (!k.sterren || d.sterren === k.sterren) && (!k.onderwerp || d.onderwerpen.includes('|' + k.onderwerp + '|'));
      const gefilterd = () => !!(keuze.sterren || keuze.onderwerp);
      const aantalKolommen = () => parseInt(getComputedStyle(lijst).getPropertyValue('--mb-rvo-kolommen'), 10) || 1;

      /* Metselwerk: elke kaart in de kortste kolom */
      const plaats = (d) => {
        let kortste = kolommen[0];
        kolommen.forEach((k) => { if (k.offsetHeight < kortste.offsetHeight) kortste = k; });
        d.item.hidden = false;
        kortste.appendChild(d.item);
      };

      const vulAan = () => {
        const doel = gefilterd() ? lijstNu.length : Math.min(zichtbaar, lijstNu.length);
        for (; geplaatst < doel; geplaatst++) plaats(lijstNu[geplaatst]);
      };

      const opbouw = () => {
        data.forEach((d) => { d.item.hidden = true; bron.appendChild(d.item); });
        kolommen.forEach((k) => k.remove());
        kolommen = [];
        for (let i = 0; i < aantalKolommen(); i++) {
          const k = document.createElement('ul');
          k.className = 'mb-rvo__kolom';
          k.setAttribute('role', 'list');
          lijst.appendChild(k);
          kolommen.push(k);
        }
        lijstNu = data.filter((d) => past(d, keuze));
        geplaatst = 0;
        vulAan();
      };

      /* Aantallen per keuze (gegeven de keuze in de andere groep); keuzes zonder reviews lichter en niet klikbaar */
      const tel = () => {
        opties.forEach((pil) => {
          const groep = pil.dataset.groep;
          const k = { ...keuze, [groep]: pil.dataset.waarde };
          const n = data.filter((d) => past(d, k)).length;
          const aantal = pil.querySelector('[data-aantal]');
          if (aantal) aantal.textContent = `(${n})`;
          const actief = keuze[groep] === pil.dataset.waarde;
          const isLeeg = n === 0 && !actief;
          pil.classList.toggle('is-leeg', isLeeg);
          if (isLeeg) pil.setAttribute('aria-disabled', 'true');
          else pil.removeAttribute('aria-disabled');
        });
      };

      const toon = (bijwerkenUrl) => {
        opties.forEach((pil) => {
          const actief = keuze[pil.dataset.groep] === pil.dataset.waarde;
          pil.classList.toggle('is-actief', actief);
          pil.setAttribute('aria-pressed', actief ? 'true' : 'false');
        });
        knoppen.forEach((knop) => knop.classList.toggle('is-actief', !!keuze[knop.dataset.mbRvoKnop]));
        tel();
        opbouw();
        const n = lijstNu.length;
        if (wis) wis.hidden = !gefilterd();
        if (leeg) leeg.hidden = n > 0;
        if (status) status.textContent = gefilterd() ? `${n} ${n === 1 ? 'review' : 'reviews'}` : '';
        if (bijwerkenUrl) {
          const p = new URLSearchParams(window.location.search);
          ['sterren', 'onderwerp'].forEach((g) => (keuze[g] ? p.set(g, keuze[g]) : p.delete(g)));
          const q = p.toString();
          history.replaceState(null, '', window.location.pathname + (q ? '?' + q : '') + window.location.hash);
        }
        controleerEinde();
      };

      /* Laden bij scrollen (alleen zonder filter): einde van de lijst in beeld = volgende reeks */
      const inBeeld = () => einde.getBoundingClientRect().top < window.innerHeight + 600;
      const controleerEinde = () => {
        if (gefilterd() || geplaatst >= lijstNu.length || !inBeeld()) return;
        zichtbaar += perKeer;
        vulAan();
        requestAnimationFrame(controleerEinde);
      };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((entries) => { if (entries.some((e) => e.isIntersecting)) controleerEinde(); }, { rootMargin: '0px 0px 600px 0px' }).observe(einde);
      } else {
        window.addEventListener('scroll', controleerEinde, { passive: true });
      }

      const openRij = (knop, open) => {
        const rij = document.getElementById(knop.getAttribute('aria-controls'));
        knop.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (rij) rij.hidden = !open;
      };

      sectie.addEventListener('click', (e) => {
        const knop = e.target.closest('[data-mb-rvo-knop]');
        if (knop) {
          /* Eén filter tegelijk uitgeklapt: de andere klapt in */
          const open = knop.getAttribute('aria-expanded') !== 'true';
          if (open) knoppen.forEach((k) => { if (k !== knop) openRij(k, false); });
          openRij(knop, open);
          return;
        }
        const pil = e.target.closest('.mb-filter__opties [data-groep]');
        const reset = e.target.closest('[data-mb-rvo-reset]');
        if (!pil && !reset) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault();
        if (reset) {
          keuze.sterren = '';
          keuze.onderwerp = '';
        } else {
          if (pil.classList.contains('is-leeg')) return;
          const g = pil.dataset.groep;
          keuze[g] = keuze[g] === pil.dataset.waarde ? '' : pil.dataset.waarde;
        }
        zichtbaar = perKeer;
        toon(true);
      });

      /* Ander aantal kolommen (draaien, venster groter/kleiner): opnieuw verdelen */
      let kolommenNu = aantalKolommen();
      window.addEventListener('resize', () => {
        const n = aantalKolommen();
        if (n !== kolommenNu) { kolommenNu = n; opbouw(); }
      });

      const p = new URLSearchParams(window.location.search);
      keuze.sterren = p.get('sterren') || '';
      keuze.onderwerp = p.get('onderwerp') || '';
      const eersteActief = knoppen.find((knop) => keuze[knop.dataset.mbRvoKnop]);
      if (eersteActief) openRij(eersteActief, true);
      lijst.classList.add('is-js');
      lees();
      toon(false);

      /* Meer dan 1000 reviews: volgende pagina's ophalen via de Section Rendering API en achteraan toevoegen */
      const paginas = parseInt(sectie.dataset.paginas, 10) || 1;
      const shopifySectie = sectie.closest('.shopify-section');
      const sectieId = shopifySectie ? shopifySectie.id.replace('shopify-section-', '') : '';
      if (paginas > 1 && sectieId) {
        const verzoeken = [];
        for (let pagina = 2; pagina <= paginas; pagina++) {
          const u = new URL(window.location.pathname, window.location.origin);
          u.searchParams.set(sectie.dataset.paginaParam || 'page', pagina);
          u.searchParams.set('section_id', sectieId);
          verzoeken.push(fetch(u.toString(), { credentials: 'same-origin' }).then((r) => (r.ok ? r.text() : '')).catch(() => ''));
        }
        Promise.all(verzoeken).then((htmls) => {
          htmls.forEach((html) => {
            if (!html) return;
            const doc = new DOMParser().parseFromString(html, 'text/html');
            doc.querySelectorAll('[data-mb-rvo-bron] > .mb-rvo__item').forEach((li) => bron.appendChild(document.adoptNode(li)));
          });
          lees();
          toon(false);
        });
      }
    };

    const start = () => document.querySelectorAll('[data-mb-rvo]').forEach(init);
    start();
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mublio-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (slider) => {
      if (slider.dataset.mbReady) return;
      slider.dataset.mbReady = '1';
      const track = slider.querySelector('[data-mb-rv-track]');
      const vorige = slider.querySelector('[data-mb-rv-vorige]');
      const volgende = slider.querySelector('[data-mb-rv-volgende]');
      const stap = () => {
        const item = track.querySelector('.mb-rv__item');
        if (!item) return track.clientWidth;
        return item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
      };

      const update = () => {
        const max = track.scrollWidth - track.clientWidth - 2;
        if (vorige) vorige.disabled = track.scrollLeft <= 2;
        if (volgende) volgende.disabled = track.scrollLeft >= max;
      };

      const schuif = (richting) => {
        const zichtbaar = Math.max(1, Math.floor((track.clientWidth + 1) / stap()));
        track.scrollBy({ left: richting * zichtbaar * stap() });
      };
      if (vorige) vorige.addEventListener('click', () => schuif(-1));
      if (volgende) volgende.addEventListener('click', () => schuif(1));

      /* Lees meer: alleen tonen als de tekst echt is afgekort; één kaart tegelijk open */
      const kaarten = [...track.querySelectorAll('[data-mb-rv-kaart]')];

      const zetKnop = (kaart, open) => {
        const knop = kaart.querySelector('[data-mb-rv-meer]');
        if (!knop) return;
        kaart.classList.toggle('is-open', open);
        knop.setAttribute('aria-expanded', open ? 'true' : 'false');
        const label = knop.querySelector('[data-mb-rv-meer-label]');
        if (label) label.textContent = open ? knop.dataset.labelMinder : knop.dataset.labelMeer;
        /* Open: knop inline achter de laatste zin. Dicht: terug naast de alinea, onderaan rechts. */
        const tekst = kaart.querySelector('[data-mb-rv-tekst]');
        const vak = kaart.querySelector('[data-mb-rv-tekstvak]');
        if (open && tekst && knop.parentElement !== tekst) tekst.appendChild(knop);
        if (!open && vak && knop.parentElement !== vak) vak.appendChild(knop);
      };

      const sluitAlles = () => {
        kaarten.forEach((k) => zetKnop(k, false));
        track.classList.remove('is-uitgevouwen');
        track.style.removeProperty('--mb-rv-h');
      };

      const meetAfkorting = () => {
        const open = kaarten.find((k) => k.classList.contains('is-open'));
        if (open) return;
        kaarten.forEach((kaart) => {
          const tekst = kaart.querySelector('[data-mb-rv-tekst]');
          const knop = kaart.querySelector('[data-mb-rv-meer]');
          if (!tekst || !knop) return;
          knop.hidden = tekst.scrollHeight <= tekst.clientHeight + 1;
        });
      };

      kaarten.forEach((kaart) => {
        const knop = kaart.querySelector('[data-mb-rv-meer]');
        if (!knop) return;
        knop.addEventListener('click', () => {
          const wasOpen = kaart.classList.contains('is-open');
          if (!track.classList.contains('is-uitgevouwen')) {
            /* Hoogte van de dichte rij vastleggen voordat er iets uitklapt */
            const item = kaart.closest('.mb-rv__item');
            track.style.setProperty('--mb-rv-h', item.getBoundingClientRect().height + 'px');
          }
          kaarten.forEach((k) => zetKnop(k, false));
          if (wasOpen) {
            sluitAlles();
          } else {
            track.classList.add('is-uitgevouwen');
            zetKnop(kaart, true);
          }
          /* De knop is verplaatst in de DOM: focus terugzetten voor toetsenbordgebruikers */
          knop.focus({ preventScroll: true });
        });
      });

      let breedte = window.innerWidth;
      window.addEventListener('resize', () => {
        update();
        if (window.innerWidth !== breedte) {
          breedte = window.innerWidth;
          sluitAlles();
          meetAfkorting();
        }
      });

      track.addEventListener('scroll', update, { passive: true });
      update();
      meetAfkorting();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(meetAfkorting);
    };

    const start = () => document.querySelectorAll('[data-mb-rv]').forEach(init);
    start();
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();
})();
